import Filter from "bad-words";

// import our bad words
import { array as BadWordsList } from "badwords-list";
import { words as MoreBadWordsList } from "bad-words/lib/lang.json";
import Blacklist from "./blacklist";

/**
 * Merges supplied arrays and removes duplicates
 * @param  {...any} args
 */
function mergeDeduped(...args) {
  const items = [];

  args.forEach((array) => {
    array.forEach((item) => {
      if (!items.includes(item)) {
        items.push(item);
      }
    });
  });

  return items;
}

/**
 * Appends a string to all the other words in the array
 * @param {*} wordsArray
 * @param {*} append
 */
function swearAppend(wordsArray, append) {
  return wordsArray.map((w) => `${w}${append}`);
}

const filter = new Filter({ emptyList: true });

const mergedImported = mergeDeduped(BadWordsList, MoreBadWordsList, Blacklist);

filter.addWords(
  ...mergedImported,
  ...swearAppend(mergedImported, "face"),
  ...swearAppend(mergedImported, "eater"),
  ...swearAppend(mergedImported, "licker")
);

export default filter;
